import React, { useState } from "react";
import { ProcessWrapper, ProgressBar, ProgressBarIndicator } from "../styled";
import Contact from "../../components/contact/contact";
import Question from "../../components/question";
import { ReactComponent as HandsFlower } from "../../assets/img/svg/confiansa_regalo de dinero.svg";
import { ReactComponent as House } from "../../assets/img/svg/confiansa_casa.svg";
import { ReactComponent as Bill } from "../../assets/img/svg/confiansa_billete.svg";

export default function Heritage({
  finishProcess,
  setRecommendation,
  startOver,
  setContact,
  setAssuranceUrl,
  contact,
  secondaryStep,
  specificStep,
}) {
  const [step, setStep] = useState(
    secondaryStep !== undefined ? secondaryStep : 0
  );
  const [stage, setStage] = useState(0);

  const nextStep = () => {
    setStep(step + 1);
  };

  const goToStep = (newStep) => {
    setStep(newStep);
  };

  return (
    <ProcessWrapper>
      <ProgressBar>
        <ProgressBarIndicator progressWidth={(100 * (stage + 1)) / 3} />
      </ProgressBar>

      {step === 0 && (
        <Contact
          nextStep={nextStep}
          setContact={setContact}
          contact={contact}
        />
      )}
      {step === 1 && (
        <Question
          goToStep={() => goToStep(0)}
          text="¿Qué clase de patrimonio deseas proteger?"
          icon={<HandsFlower fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Mi vivienda",
              action: () => {
                setStep(2);
                setStage(stage + 1);
              },
            },
            {
              label: "Mis ingresos",
              action: () => {
                setStep(3);
              },
            },
            {
              label: "Mis vehículos",
              action: () => {
                specificStep("vehicle", 1);
              },
            },
          ]}
        />
      )}
      {step === 2 && (
        <Question
          goToStep={() => goToStep(1)}
          text="¿Cómo deseas proteger tu vivienda?"
          icon={<House fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "Respaldar una deuda hipotecaria",
              action: () => {
                setRecommendation({
                  title: "Plan de Vida 360",
                  phrase1: "  ¡Te recomendamos Seguro Plan de Vida 360!  ",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/vida-360/");
                finishProcess();
              },
            },
            {
              label: "La infraestructura",
              action: () => {
                setRecommendation({
                  title: "Incendio y Líneas Aliadas",
                  phrase1:
                    "  ¡Te recomendamos Seguro de Incendio y Líneas Aliadas!  ",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/contacto/");
                finishProcess();
              },
            },
            {
              label: "El amueblado / Electrodomésticos, etc.",
              action: () => {
                setRecommendation({
                  title: "Seguro Contenido de Hogar",
                  phrase1: "  ¡Te recomendamos Seguro Contenido de Hogar!  ",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/contacto/");
                finishProcess();
              },
            },
          ]}
        />
      )}
      {step === 3 && (
        <Question
          goToStep={() => goToStep(1)}
          text="¿Qué deseas garantizar?"
          icon={<Bill fill="#00c1d4" style={{ maxHeight: "100px" }} />}
          options={[
            {
              label: "El pago de mi tarjeta de crédito",
              action: () => {
                setRecommendation({
                  title: "Cuota Garantizada para Tarjeta de Crédito",
                  phrase1:
                    "  ¡Te recomendamos  Cuota Garantizada para Tarjeta de Crédito!  ",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/contacto/");
                finishProcess();
              },
            },
            {
              label: "El pago de mi préstamo",
              action: () => {
                setRecommendation({
                  title: "Plan de vida 360",
                  phrase1: "  ¡Te recomendamos Plan de vida 360!  ",
                  phrase2: "",
                });
                setAssuranceUrl("https://confiansa.bi.com.gt/vida-360/");
                finishProcess();
              },
            },
            {
              label: "Mi sueldo en caso de fallecimiento accidental",
              action: () => {
                setRecommendation({
                  title: "Seguro de Accidentes Personales",
                  phrase1: "¡Te recomendamos Seguro de Accidentes Personales",
                  phrase2: "",
                });
                setAssuranceUrl(
                  "https://confiansa.bi.com.gt/seguro-de-accidentes-personales/"
                );
                finishProcess();
              },
            },
          ]}
        />
      )}
    </ProcessWrapper>
  );
}
